<template>
  <ArticleCardContainer
    :show-pagination="showPagination"
    :start-from="elem.attributes.startFrom"
  />
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import ArticleCardContainer from '~/containers/ArticleCardContainer.vue';

  type Attributes = {
    pagination: boolean;
    startFrom: number;
  };

  export default defineNuxtComponent({
    name: 'ArchiveBlock',
    components: { ArticleCardContainer },

    props: {
      elem: {
        type: Object as PropType<TContent<Attributes>>,
        required: true,
      },
    },

    computed: {
      showPagination(): boolean {
        /*
        для бесконечной ленты в здоровье нам нужно отключить пагинацию.
        Для lh__health-archive мне не приходит с бэка в attributes.pagination знание о том,
        отображать мне пагинацию или нет. Гоша сказал, что по startFrom только смотреть.
        Итак, если в блоке архива здоровья мне приходит startFrom === 0, значит нужен лонгрид,
        значит нужно отключить пагинацию. Если там 1 или 6, то отображаем её
      */
        if (this.elem.type === 'lh__health-archive') {
          return Boolean(this.elem.attributes.startFrom);
        }
        return this.elem.attributes.pagination;
      },
    },
  });
</script>
